import * as React from 'react';

export default class Callback extends React.Component<{}> {
  public render() {
    return <div className="callback" />;
  }
}
